import React from 'react';
import FormContact from '../../components/FormContact';

const Contact = () => {
  return (
    <div
      id="Contact"
      className="flex flex-col w-full h-screen justify-center items-center bg-gray-200">
      <h2 className="text-2xl text-gray-800 font-bold md:text-4xl text-center pb-20">
        Contáctame
      </h2>
      <FormContact />
    </div>
  );
};

export default Contact;
